import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrCG: CultureInfo = {
  name: 'fr-CG',
  displayName: 'français (Congo-Brazzaville)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-CG',
  parent: CultureInfoFr
};
